  (function () {
    // Prompt user to login with Vipps after adding to cart the first time in a session and is not logged in and add event
    // https://app.asana.com/1/292354344737410/project/1209176817795635/task/1211452453271448
    // Only prompt guests, and only once per browser session
    var isLoggedIn = !!(window.Shopify && window.Shopify.customer && window.Shopify.customer.id);
    var PROMPT_KEY_SHOWN = 'vippsLoginPromptOnAddToCartShown';
    var PROMPT_KEY_LOCATION = 'vippsLoginPromptOnAddToCartShownLocation';
    var PROMPT_KEY_DISABLED = 'vippsLoginPromptOnAddToCartDisabled';
    var customerAuth = window.theme && window.theme.customerAuth;

    function readSession(key) {
      try { return sessionStorage.getItem(key); } catch (e) { return null; }
    }

    function markShown() {
      try { sessionStorage.setItem(PROMPT_KEY_SHOWN, '1'); } catch (e) { /* Login remains available. */ }
    }

    var locationToRedirect = customerAuth ? null : readSession(PROMPT_KEY_LOCATION);
    if (locationToRedirect) {
      sessionStorage.removeItem(PROMPT_KEY_LOCATION);
      window.location.href = locationToRedirect;
    }

    // read query-params if env is there add it url
    var queryParams = new URLSearchParams(window.location.search);
    var env = queryParams.get('env');

    function shouldPrompt() {
      var sessionStorageDisabledValue = readSession(PROMPT_KEY_DISABLED);
      var isDisabled = sessionStorageDisabledValue === '1';

      var sessionStorageShownValue = readSession(PROMPT_KEY_SHOWN);
      var wasSeen = sessionStorageShownValue === '1';

      var sessionStorageLocationValue = readSession(PROMPT_KEY_LOCATION);
      console.log(`[vipps login prompt add to cart shouldPrompt()]`, {
        isLoggedIn,
        sessionStorageDisabledValue,
        isDisabled,
        sessionStorageShownValue,
        wasSeen,
        sessionStorageLocationValue,
      })

      if (isLoggedIn) {
        return false;
      }
      if (wasSeen) {
        return false;
      }
      if (isDisabled) {
        return false;
      }
      return true;
    }

    var shouldInitializeVippsLoginPromptModal = shouldPrompt();
    console.log(`[vipps login prompt add to cart shouldInitializeVippsLoginPromptModal`, {
      shouldInitializeVippsLoginPromptModal
    })
    if (!shouldInitializeVippsLoginPromptModal) {
      return;
    }

    // Build and show the Vipps login prompt modal
    function showVippsPrompt() {
      var promptEvent = customerAuth ? 'prompt_customer_login_after_add_to_cart' : 'prompt-vipps-login-after-add-to-cart';
      if (typeof window.gtag === 'function') window.gtag('event', promptEvent, {});
      if (window.amplitude && typeof window.amplitude.track === 'function') window.amplitude.track(promptEvent, {});

      // Guard against multiple renders
      if (document.getElementById('vipps-login-prompt-overlay')) {
        return;
      }

      var overlay = document.createElement('div');
      overlay.id = 'vipps-login-prompt-overlay';
      overlay.className = 'wishlist-prompt-modal-overlay active';

      var modal;
      if (customerAuth) {
        var template = document.getElementById('customer-auth-prompt');
        if (!template) return;
        modal = template.content.firstElementChild.cloneNode(true);
      } else {
        modal = document.createElement('div');
        modal.className = 'wishlist-prompt-modal';
        modal.innerHTML = ""
          + '<div class="wishlist-prompt-modal-content">'
          + '  <div class="wishlist-prompt-modal-header">'
          + '    <button type="button" class="wishlist-prompt-modal-close" aria-label="Lukk">×</button>'
          + '  </div>'
          + '  <div class="wishlist-prompt-modal-body">'
          + '    <p>Logg inn med Vipps for en<br> raskere utsjekk ✨</p>'
          + '  </div>'
          + '  <div class="wishlist-prompt-modal-footer">'
          + `  <button type="button" id="vipps-login-action" data-event="login-vipps-prompted-after-add-to-cart" disabled style='cursor: pointer'>
                 <svg width="250" height="44" viewBox="0 0 250 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="250" height="44" rx="5" fill="#FF5B24"></rect>
                  <path d="M31.6435 28.5V15.4651H33.974V26.5398H39.954V28.5H31.6435ZM45.8424 28.6987C42.8795 28.6987 41.0909 26.7656 41.0909 23.5679V23.5498C41.0909 20.3792 42.9066 18.437 45.8424 18.437C48.7872 18.437 50.5938 20.3701 50.5938 23.5498V23.5679C50.5938 26.7656 48.7962 28.6987 45.8424 28.6987ZM45.8424 26.874C47.4051 26.874 48.2904 25.6545 48.2904 23.5769V23.5588C48.2904 21.4812 47.3961 20.2527 45.8424 20.2527C44.2796 20.2527 43.3854 21.4812 43.3854 23.5588V23.5769C43.3854 25.6545 44.2796 26.874 45.8424 26.874ZM56.8978 31.9688C54.2962 31.9688 52.7334 30.8577 52.5076 29.1956L52.5166 29.1685H54.7659L54.775 29.1956C54.9285 29.8279 55.6783 30.2705 56.9339 30.2705C58.4695 30.2705 59.3638 29.5569 59.3638 28.2922V26.4043H59.2103C58.6412 27.4612 57.5662 28.0393 56.2022 28.0393C53.7 28.0393 52.1463 26.1062 52.1463 23.3059V23.2878C52.1463 20.4333 53.7 18.4641 56.2474 18.4641C57.6114 18.4641 58.6773 19.1326 59.2374 20.2527H59.3548V18.6267H61.6041V28.2561C61.6041 30.5325 59.7793 31.9688 56.8978 31.9688ZM56.8978 26.2507C58.4605 26.2507 59.4 25.0493 59.4 23.3059V23.2878C59.4 21.5444 58.4515 20.334 56.8978 20.334C55.335 20.334 54.4498 21.5444 54.4498 23.2878V23.3059C54.4498 25.0493 55.335 26.2507 56.8978 26.2507ZM68.4048 31.9688C65.8032 31.9688 64.2405 30.8577 64.0146 29.1956L64.0237 29.1685H66.2729L66.282 29.1956C66.4355 29.8279 67.1853 30.2705 68.4409 30.2705C69.9766 30.2705 70.8708 29.5569 70.8708 28.2922V26.4043H70.7173C70.1482 27.4612 69.0732 28.0393 67.7092 28.0393C65.207 28.0393 63.6533 26.1062 63.6533 23.3059V23.2878C63.6533 20.4333 65.207 18.4641 67.7544 18.4641C69.1184 18.4641 70.1843 19.1326 70.7444 20.2527H70.8618V18.6267H73.1111V28.2561C73.1111 30.5325 71.2864 31.9688 68.4048 31.9688ZM68.4048 26.2507C69.9675 26.2507 70.907 25.0493 70.907 23.3059V23.2878C70.907 21.5444 69.9585 20.334 68.4048 20.334C66.842 20.334 65.9568 21.5444 65.9568 23.2878V23.3059C65.9568 25.0493 66.842 26.2507 68.4048 26.2507ZM81.5546 16.9736C80.8139 16.9736 80.2086 16.3865 80.2086 15.6458C80.2086 14.9141 80.8139 14.3179 81.5546 14.3179C82.2863 14.3179 82.8915 14.9141 82.8915 15.6458C82.8915 16.3865 82.2863 16.9736 81.5546 16.9736ZM80.4254 28.5V18.6267H82.6747V28.5H80.4254ZM85.2389 28.5V18.6267H87.4881V20.1353H87.6417C88.1114 19.0784 89.0599 18.437 90.4872 18.437C92.6913 18.437 93.8927 19.7649 93.8927 22.1135V28.5H91.6434V22.6375C91.6434 21.1018 91.0201 20.325 89.6561 20.325C88.3192 20.325 87.4881 21.2644 87.4881 22.7458V28.5H85.2389ZM96.3484 28.5V18.6267H98.5977V20.1353H98.7513C99.221 19.0784 100.169 18.437 101.597 18.437C103.801 18.437 105.002 19.7649 105.002 22.1135V28.5H102.753V22.6375C102.753 21.1018 102.13 20.325 100.766 20.325C99.4288 20.325 98.5977 21.2644 98.5977 22.7458V28.5H96.3484ZM112.19 28.5V18.6267H114.439V20.1624H114.593C115.018 19.0603 116.011 18.437 117.303 18.437C118.64 18.437 119.615 19.1235 120.04 20.2166H120.194C120.672 19.1416 121.81 18.437 123.184 18.437C125.171 18.437 126.363 19.6565 126.363 21.707V28.5H124.114V22.2581C124.114 20.9753 123.527 20.325 122.325 20.325C121.151 20.325 120.392 21.2012 120.392 22.3303V28.5H118.143V22.0955C118.143 21.0024 117.466 20.325 116.363 20.325C115.252 20.325 114.439 21.2644 114.439 22.4929V28.5H112.19ZM133.056 28.6987C130.12 28.6987 128.34 26.7295 128.34 23.5859V23.5769C128.34 20.4695 130.138 18.437 132.947 18.437C135.756 18.437 137.491 20.4062 137.491 23.3872V24.1279H130.59C130.617 25.8984 131.574 26.9282 133.101 26.9282C134.32 26.9282 135.016 26.314 135.233 25.8623L135.26 25.7991H137.401L137.373 25.8804C137.057 27.1541 135.738 28.6987 133.056 28.6987ZM132.974 20.1985C131.719 20.1985 130.779 21.0476 130.608 22.6194H135.296C135.142 21.0024 134.23 20.1985 132.974 20.1985ZM143.099 28.6626C140.624 28.6626 139.052 26.7024 139.052 23.5769V23.5588C139.052 20.4153 140.597 18.4641 143.099 18.4641C144.454 18.4641 145.583 19.1326 146.098 20.1985H146.252V14.8057H148.51V28.5H146.252V26.9553H146.098C145.556 28.0303 144.49 28.6626 143.099 28.6626ZM143.804 26.7656C145.339 26.7656 146.288 25.5552 146.288 23.5769V23.5588C146.288 21.5806 145.33 20.3611 143.804 20.3611C142.277 20.3611 141.338 21.5715 141.338 23.5588V23.5769C141.338 25.5642 142.268 26.7656 143.804 26.7656Z" fill="white"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M220 20.3784C219.28 17.6307 217.531 16.54 215.145 16.54C213.211 16.54 210.784 17.6307 210.784 20.2571C210.784 21.954 211.957 23.2876 213.869 23.6312L215.68 23.9542C216.914 24.1763 217.264 24.6411 217.264 25.2674C217.264 25.9745 216.503 26.3784 215.371 26.3784C213.89 26.3784 212.965 25.8532 212.82 24.3783L210.208 24.7824C210.619 27.6308 213.17 28.8029 215.474 28.8029C217.655 28.8029 219.979 27.5501 219.979 25.0249C219.979 23.3075 218.93 22.0553 216.976 21.6912L214.981 21.3279C213.869 21.1259 213.499 20.5804 213.499 20.0551C213.499 19.3884 214.219 18.9645 215.207 18.9645C216.462 18.9645 217.346 19.3884 217.387 20.7823L220 20.3784ZM161.925 24.7013L164.64 16.8428H167.828L163.097 28.4994H160.731L156 16.8431H159.188L161.925 24.7013ZM178.608 20.1764C178.608 21.1055 177.868 21.752 177.004 21.752C176.14 21.752 175.399 21.1055 175.399 20.1764C175.399 19.247 176.14 18.6007 177.004 18.6007C177.868 18.6007 178.609 19.247 178.609 20.1764H178.608ZM179.102 24.2977C178.032 25.6711 176.901 26.6206 174.905 26.6207C172.869 26.6207 171.285 25.4086 170.051 23.6309C169.557 22.9035 168.796 22.742 168.24 23.1259C167.726 23.4896 167.603 24.2573 168.076 24.924C169.783 27.4897 172.149 28.9843 174.905 28.9843C177.436 28.9843 179.411 27.7724 180.953 25.7521C181.529 25.0048 181.509 24.2371 180.953 23.8128C180.439 23.4084 179.678 23.5504 179.102 24.2977ZM186.2 22.6409C186.2 25.0249 187.599 26.2776 189.163 26.2776C190.643 26.2776 192.166 25.1057 192.166 22.6409C192.166 20.2164 190.643 19.045 189.183 19.045C187.599 19.045 186.2 20.156 186.2 22.6409ZM186.2 18.4594V16.863H183.3V32.54H186.2V26.964C187.167 28.2571 188.422 28.8029 189.841 28.8029C192.495 28.8029 195.087 26.7421 195.087 22.4998C195.087 18.4388 192.392 16.5402 190.088 16.5402C188.257 16.5402 187.002 17.3683 186.2 18.4594ZM200.128 22.6409C200.128 25.0249 201.526 26.2776 203.09 26.2776C204.571 26.2776 206.093 25.1057 206.093 22.6409C206.093 20.2164 204.571 19.045 203.11 19.045C201.526 19.045 200.127 20.156 200.127 22.6409H200.128ZM200.128 18.4594V16.863H200.127H197.227V32.54H200.127V26.964C201.094 28.2571 202.349 28.8029 203.768 28.8029C206.422 28.8029 209.014 26.7421 209.014 22.4998C209.014 18.4388 206.319 16.5402 204.015 16.5402C202.184 16.5402 200.93 17.3683 200.128 18.4594Z" fill="white"></path>
                 </svg>
               </button>`
          + '  </div>'
          + '</div>';
      }

      overlay.appendChild(modal);
      document.body.appendChild(overlay);

      function dismiss() {
        markShown();
        overlay.classList.remove('active');
        setTimeout(function () {
          overlay.remove();
        }, 200);
      }

      modal.querySelector('.wishlist-prompt-modal-close').addEventListener('click', dismiss);

      if (customerAuth) {
        modal.querySelector('[data-event="customer-auth-start"]').addEventListener('click', markShown);
        return;
      }

      // Fetch Vipps auth URL and enable the button
      (function fetchVippsAuthUrl() {
        try {
          var url = 'https://g6ssodn3u8.execute-api.eu-north-1.amazonaws.com/dev/vipps/auth-url';
          if (env) {
            url += ('?env=' + encodeURIComponent(env));
          }
          fetch(url)
            .then(function (res) {
              if (!res.ok) {
                throw new Error('Network');
              }
              return res.json();
            })
            .then(function (data) {
              var authUrl = data && data.auth_url;
              var btn = document.getElementById('vipps-login-action');
              if (authUrl && btn) {
                btn.disabled = false;
                btn.addEventListener('click', function () {
                  // remember location of place where you logged in from
                  sessionStorage.setItem(PROMPT_KEY_LOCATION, window.location.href);
                  // Mark as shown so we do not prompt again this session
                  sessionStorage.setItem(PROMPT_KEY_SHOWN, '1');
                  window.location.href = authUrl;
                });
              }
            })
            .catch(function (err) {
              console.warn('Vipps auth url fetch failed', err);
            });
        } catch (e) {
          console.warn(e);
        }
      })();
    }

    // Listen for the first successful add-to-cart event from the theme
    var onAdded = function () {
      document.removeEventListener('ajaxProduct:added', onAdded);
      if (shouldPrompt()) {
        // Delay slightly to avoid fighting with other UI like the cart drawer

        // only if there is 2.5s of inactivity after click of `onAdded` event
        var lastActionTime = Date.now();
        var INTERVAL_OF_INACTIVITY_CHECK = 2500;
        var MIN_TIME_OF_INACTIVITY_TO_SHOW_PROMPT = 2000;
        // on any action (click, scroll, touch, mousemove, keydown) of user, update lastActionTime
        document.addEventListener('click', () => {
          lastActionTime = Date.now();
        });
        document.addEventListener('scroll', () => {
          lastActionTime = Date.now();
        });
        document.addEventListener('touchstart', () => {
          lastActionTime = Date.now();
        });
        document.addEventListener('mousemove', () => {
          lastActionTime = Date.now();
        });
        document.addEventListener('keydown', () => {
          lastActionTime = Date.now();
        });
        
        setTimeout(() => {
          var currentTime = Date.now();
          var timeSinceLastAction = currentTime - lastActionTime;
          var shouldShowPrompt = timeSinceLastAction >= MIN_TIME_OF_INACTIVITY_TO_SHOW_PROMPT;
          console.log(`[vipps login prompt add to cart inactivityCheck()]`, {
            lastActionTime,
            currentTime,
            timeSinceLastAction,
            shouldShowPrompt,
            INTERVAL_OF_INACTIVITY_CHECK,
            MIN_TIME_OF_INACTIVITY_TO_SHOW_PROMPT,
          })
          if (shouldShowPrompt) {
            showVippsPrompt();
          }
        }, INTERVAL_OF_INACTIVITY_CHECK);
      }
    };
    document.addEventListener('ajaxProduct:added', onAdded, {once: true});
  })();
    
